function runJsonCollectionBannersVysen() {
  const section = document.querySelector('[data-section-type="collection"]');
  if (!section) return false;

  const rawData = section.getAttribute('data-collection-banners');
  if (!rawData) return false;

  let data;
  try {
    data = JSON.parse(rawData);
  } catch (error) {
    console.error('JSON banners inválido en collection_banners:', error);
    return false;
  }

  const banners = data?.banners || [];
  if (!banners.length) return false;

  const grid = section.querySelector('.js-grid');
  if (!grid) return false;

  const productItems = Array.from(grid.children).filter((child) => {
    return (
      child.nodeType === 1 &&
      !child.classList.contains('collection-json-banner-item')
    );
  });

  if (!productItems.length) return false;

  banners.forEach((banner, index) => {
    if (!banner || !banner.position) return;

    const positionIndex = Number(banner.position) - 1;
    if (Number.isNaN(positionIndex) || positionIndex < 0) return;
    if (positionIndex >= productItems.length) return;

    const existingBanner = grid.querySelector(
      `.collection-json-banner-item[data-banner-index="${index}"]`
    );
    if (existingBanner) return;

    let mediaHTML = '';

    if (banner.video) {
      mediaHTML = `
        <video
          src="${banner.video}"
          autoplay
          muted
          loop
          playsinline
          preload="metadata"
        ></video>
      `;
    } else if (banner.image) {
      mediaHTML = `
        <img
          src="${banner.image}"
          alt=""
          loading="lazy"
        >
      `;
    } else {
      return;
    }

    const contentHTML = banner.link
      ? `<a href="${banner.link}" target="_blank" rel="noopener noreferrer">${mediaHTML}</a>`
      : mediaHTML;

    const bannerHTML = `
      <div
        class="collection-json-banner-item collection-json-banner-item--${index + 1}"
        data-banner-index="${index}"
        data-banner-position="${banner.position}"
      >
        <div class="collection-json-banner-media">
          ${contentHTML}
        </div>
      </div>
    `;

    const referenceItem = productItems[positionIndex];
    referenceItem.insertAdjacentHTML('afterend', bannerHTML);
  });

  return true;
}

document.addEventListener('DOMContentLoaded', function () {
  runJsonCollectionBannersVysen();
});